import { render, staticRenderFns } from "./ListRelacion.vue?vue&type=template&id=3b4e499e&"
import script from "./ListRelacion.vue?vue&type=script&lang=js&"
export * from "./ListRelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports